<template>
  <v-app-bar v-bind="$attrs" app dense color="white" elevation="3">
    <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
    <strong>{{ title }}</strong>
    <v-spacer />
    <slot />
    <template v-slot:extension v-if="$slots.extension">
      <slot name="extension" />
    </template>
  </v-app-bar>
</template>

<script>
import { sync } from 'vuex-pathify'

export default {
  name: 'AppBar',

  props: {
    title: String
  },

  computed: {
    drawer: sync('app/drawer')
  }
}
</script>
